require('angular')
TitleInterceptor = require("./title-interceptor")

angular.module 'gnp-app-title', []
  .run TitleInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/title/title-module.coffee